import React from 'react';
import { DocumentBox } from '../../../../../../components';
import { type AcademicRefereeData } from '../../../../../Monitor/graphql';
import { APPLICATION_TEXT } from '../../../../../Monitor/components/lang';

type AcademicRefereeConfirmBoxProps = {
  titleArea: React.ReactNode;
  academicReferee: AcademicRefereeData;
};

const ACADEMIC_REFEREE = APPLICATION_TEXT.ACADEMIC_REFEREE;
export const AcademicRefereeConfirmBox: React.FunctionComponent<
  AcademicRefereeConfirmBoxProps
> = (props: AcademicRefereeConfirmBoxProps) => {
  const { academicReferee, titleArea } = props;

  const {
    title,
    name,
    institution,
    position,
    relationship,
    email,
    referenceReport,
  } = academicReferee;

  const hasReferenceReport: boolean = Boolean(referenceReport?.id);

  const refereeInformation = [
    {
      label: ACADEMIC_REFEREE.REFEREE_TITLE,
      value: title,
      isFullwidth: false,
    },
    {
      label: ACADEMIC_REFEREE.REFEREE_NAME,
      value: `${name.surname?.toUpperCase()} ${name.givenName}`,
      isFullwidth: false,
    },
    {
      label: ACADEMIC_REFEREE.INSTITUTION,
      value: institution,
      isFullwidth: true,
    },
    {
      label: ACADEMIC_REFEREE.POSITION,
      value: position,
      isFullwidth: false,
    },
    {
      label: ACADEMIC_REFEREE.RELATIONSHIP,
      value: relationship,
      isFullwidth: false,
    },

    {
      label: ACADEMIC_REFEREE.EMAIL,
      value: email,
      isFullwidth: true,
    },
  ];

  return (
    <div className="m-2 p-4 bg-[#F6F6F6]">
      {titleArea}
      <div className="grid grid-cols-2 gap-2 p-4 text-sm">
        {refereeInformation.map((item, index) => {
          return (
            <div key={index} className={`${item.isFullwidth && 'col-span-2'}`}>
              <span className="text-[#224295]">{item.label}</span>:&nbsp;&nbsp;
              {item.value}
              <hr className="mt-2" />
            </div>
          );
        })}
      </div>

      <div>
        <div className="py-2 italic text-[#8c8c8c]">{`Referee's Reports`}</div>
        {hasReferenceReport ? (
          <DocumentBox file={referenceReport} />
        ) : (
          <div className="text-sm">{APPLICATION_TEXT.NA}</div>
        )}
      </div>
    </div>
  );
};
